/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListFlowMeta } from '../../models/api-response-list-flow-meta';

export interface ListFlowMeta$Params {
  wabaId?: string;
  senderReference?: string;
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function listFlowMeta(http: HttpClient, rootUrl: string, params: ListFlowMeta$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListFlowMeta>> {
  const rb = new RequestBuilder(rootUrl, listFlowMeta.PATH, 'get');
  if (params) {
    rb.query('wabaId', params.wabaId, {});
    rb.query('senderReference', params.senderReference, {});
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListFlowMeta>;
    })
  );
}

listFlowMeta.PATH = '/v1/api/ui/flow-meta/list';
